import { Injectable } from '@angular/core';
/**
 * L2-S1/T7: moved from `src/app/shared/components/comments/comments-api.service.ts` alongside
 * `CommentsComponent`. The old host path is a re-export shim.
 */
import { HttpMethods } from '@miq/platform';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Comment } from '@miq/shared-models';

const converstationUrl = (type: string, converstaionId: string) => `/notes/${type}/${converstaionId}`;

@Injectable({
  providedIn: 'root',
})
export class CommentsApiService extends HttpMethods {
  private readonly comments: Comment[];

  constructor(http: HttpClient) {
    super(http);
  }

  create(type: string, converstaionId: string, comment: Comment) {
    return this.httpPost(`${converstationUrl(type, converstaionId)}`, comment);
  }

  update(type: string, converstaionId: string, { id, message }: Comment) {
    return this.httpPut(`${converstationUrl(type, converstaionId)}/${id}`, { message });
  }

  delete(type: string, converstaionId: string, { id }: Comment) {
    return this.httpDelete(`${converstationUrl(type, converstaionId)}/${id}`);
  }

  getConverstaion(type: string, converstaionId: string): Observable<Comment[]> {
    return <Observable<Comment[]>>this.httpGet(`${converstationUrl(type, converstaionId)}`);
  }

  getUnreadCount(type: string, converstaionId: string): Observable<number> {
    return <Observable<number>>this.httpGet(`${converstationUrl(type, converstaionId)}/unreadcount`);
  }

  updateLastSeen(type: string, converstaionId: string) {
    return this.httpPut(`${converstationUrl(type, converstaionId)}/lastseen`, {});
  }
}
